import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function ValveDemo() {
  return (
    <div className="fixed inset-0 bg-[#0f1d36] z-[60]" data-testid="valve-demo-page">
      <SEO
        title="The Duckbill-Umbrella Valve | WearSpray"
        description="An interactive 3D model of WearSpray's patented duckbill-umbrella combination valve, showing closed, forward flow and reverse flow states."
        path="/technology/valve"
        noindex
      />
      <Link
        to="/technology"
        data-testid="valve-demo-back-link"
        className="absolute left-4 top-4 z-10 font-mono text-[11px] tracking-[0.12em] uppercase text-white/80 bg-black/40 backdrop-blur px-4 py-2.5 rounded-full hover:text-white hover:bg-black/60 transition-colors flex items-center gap-2"
      >
        <ArrowLeft size={14} />
        Back to Technology
      </Link>
      <iframe
        src="/interactive/valve.html"
        title="Duckbill-umbrella combination valve interactive 3D model"
        className="w-full h-full border-0"
        data-testid="valve-demo-iframe"
      />
    </div>
  );
}
